<template>
  <div v-if="!isMantenance" id="shipping-sc" class="panel-body">
    <p class="text-size-20">ACROSS倉庫にある商品をSTOCKCREW倉庫へ出荷 (納品) する依頼を作成することができます </p>
    <div v-if="isPremiumPlan && isUseScWarehouse">
      <div class="mr-t-15 text-warning bg-warning font-bold" style="margin-left: 30px; width: 850px;">
        <span style="padding: 10px;">2営業日以内を目途に出荷されます。</span>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">1</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">基本情報入力</span>
        </div>
        <div class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <div class="box-delivery-name m-b-md">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="delivery-name"><strong>出荷名</strong></div>
              </div>
              <div class="col-md-10 col-lg-7">
                <input type="text" :class="['form-control', shippingName ? '' : 'bg-no-input']" v-model.trim="shippingName">
                <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
                <div v-if="validateErrors.shippingName.length" class="text-red"><b>{{ validateErrors.shippingName[0]}}</b></div>
              </div>
            </div>
          </div>
          <div class="box-origin-info-default m-b-sm">
            <div class="row">
              <div class="col-md-2 col-lg-1 w-150">
                <div class="m-b-sm"><strong>発送元情報</strong></div>
              </div>
              <div class="col-md-9 col-lg-10">
                ACROSS倉庫
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mr-t-20" style="min-width: 1500px;">
        <div class="flexbox gap-15">
          <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" stroke="#008cc6" stroke-width="3" fill="#008cc6" />
            <text x="50%" y="50%" text-anchor="middle" dominant-baseline="central" font-size="20" fill="#fff">2</text>
          </svg>
          <span class="font-bold text-size-16 text-primary">商品情報入力</span>
        </div>
        <div id="product-input" class="mr-t-10 bg-white mr-l-30" style="border: 1px solid #ccc; margin-left: 30px; padding: 10px;">
          <fixed-header v-show="isShowFixedHeader" :textBtnRegister="'出荷依頼'" @handleClickAdd="openModalDeliveryProductAdd()" @handleClickRegister="submitValidate()"/>
          <p class="">出荷する商品を選択し、商品情報を入力してください。</p>
          <button type="button" class="btn btn-primary check-maintenance" @click.prevent="openModalDeliveryProductAdd()">商品選択</button>
          <button type="button" class="btn btn-warning check-maintenance" @click.prevent="openModalUpload()">CSVアップロード</button>
          <div v-if="selectedProducts.length" class="table-selected-products">
            <table class="full-width">
              <thead>
                <tr>
                  <th class="text-center w-150">出荷する商品</th>
                  <th style="min-width: 500px;"></th>
                  <th class="text-right w-200">STOCKCREW在庫数</th>
                  <th class="text-right w-200">ACROSS在庫数</th>
                  <th class="w-120">出荷予定数</th>
                  <th class="text-center w-100">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(selectedProduct, index) in selectedProducts" :key="index">
                  <td class="text-center">
                    <div class="box-selected-product-image w-40">
                      <img :src="selectedProduct.image" alt="" class="selected-product-image img-responsive">
                    </div>
                    <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(selectedProduct.status_str)}`">{{ selectedProduct.status_str }}</div>
                  </td>
                  <td>
                    <div class="m-b-xs">{{ selectedProduct.itemName }}</div>
                    <div><b>ASIN：</b>{{selectedProduct.asin}} / <b>SKU：</b>{{ selectedProduct.sku }} </div>
                    <div><b>商品ID：</b>{{selectedProduct.itemId}} / <b>商品ラベル：</b>{{ selectedProduct.goodsLabel }}</div>
                  </td>
                  <td class="text-right">
                    {{ formatNumber(selectedProduct.scQuantity) }} 個
                  </td>
                  <td colspan="2">
                    <tr>
                      <td class="text-right w-200 no-borders no-padding">
                        <span class="">{{ formatNumber(selectedProduct.acrossQuantity) }} 個</span>
                        <br>
                        <div v-if="selectedProduct.dueDateManageFlg" class="product-bubble-wrapper">
                          <a href="javascript:void(0)" @click="getStockByExpDate($event, selectedProduct)" @mouseleave="closeBubble($event)" class="text--underline">有効期限毎に表示</a>
                          <div v-show="false" class="product-bubble bubble">
                            <div v-if="stockInfo" v-for="(item, index) in stockInfo" :key="index">
                              <span v-if="item.quantity > 0">{{ item.expirationDateDisplay }} : {{ item.quantity }}個</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="no-borders">
                        <input type="text" class="form-control expected-delivery-number text-right mr-l-10" :class="parseInt(selectedProduct.quantity) && parseInt(selectedProduct.quantity) <= parseInt(selectedProduct.acrossQuantity) ? '' : 'bg-no-input'" v-model="selectedProduct.quantity" @input="selectedProduct.quantity = handleInputQuantity(selectedProduct.quantity)">
                      </td>
                    </tr>
                    <div v-if="validateErrors.quantity[selectedProduct.itemId] && validateErrors.quantity[selectedProduct.itemId].length" class="text-red text-right"><b>{{ validateErrors.quantity[selectedProduct.itemId][0]}}</b></div>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-delete-selected-product check-maintenance" @click.prevent="deleteSelectedProduct(selectedProduct)">削除</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center m-b-md m-t-md">
              <button type="button" class="btn btn-primary custom-btn check-maintenance" @click.prevent="submitValidate">
                出荷依頼
                <i class="fa fa-check fa-lg mr-l-5" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-else class="empty-products text-center">
            <h3 class="m-b-xl text-center"><strong>商品選択より、出荷する商品を選択してください。</strong></h3>
          </div>
        </div>
      </div>
    </div>
    <upgrade-plan-modal
      v-if="isShowUpgradePlanModal"
      @close="closeUpgradePlanModal"
    />
    <require-use-sc-warehouse-modal
      v-if="isShowRequireUseWarehouseModal"
      @close="closeRequireUseWarehouseModal"
    />
    <shipping-sc-product-add
      v-if="openShippingProductAddModal"
      ref="shippingScProductAddModal"
      :iconUrls="iconUrls"
      :selectedProducts="selectedProducts"
      @close="closeModalProductAdd"
      @handleSelectedProduct="handleSelectedProduct"
      @handleSelectedProducts="handleSelectedProducts"
    />
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
    <modal-confirm
      v-if="openShippingProductsAddConfirmModal"
      :message="shippingProductsAddConfirmMessage"
      @confirm="updateShippingSc"
      @close="closeModalConfirmShippingProductsAdd"
    />
    <modal-alert
      v-if="openAlertProductsAddedModal"
      :message="alertProductsAddedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <upload-csv-modal
      v-if="isShowUploadModal"
      :header="uploadCsvHeader"
      :uploadUrl="'Warehouse/across/shipping/sc/product-available/upload'"
      :needProductId="true"
      :settingProductIdOptions="settingProductIdOptions"
      @handleDownloadTemplate="handleDownloadTemplate"
      @handleUploadSuccess="handleUploadSuccess"
      @close="closeUploadModal"
    />
    <modal-alert
      v-if="openUploadedModal"
      :message="uploadedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeUploadedModal"
    />
  </div>
  <maintenance-modal v-else :html="userInfo.acrossDeliveryStopExp" :hasBypassMaintenance="true"  @close="closeMaintenanceModal" @bypassMaintenance="bypassMaintenance" />
</template>

<script>
import { mapGetters } from 'vuex'
import Util from '@/common/utility'
import moment from 'moment'
import SettingService from '@/services/settingservice'
import ModalAlert from '@/components/ModalAlert'
import ModalConfirm from '@/components/ModalConfirm'
import ShippingScProductAdd from '@/view/warehouseAcross/components/ShippingScProductAdd'
import RequireUseScWarehouseModal from './components/RequireUseScWarehouseModal'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'
import FixedHeader from './components/FixedHeader'
import UploadCsvModal from '@/components/UploadCsvModal'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import MaintenanceModal from '@/view/warehouses/MaintenanceModal'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAlert,
    ModalConfirm,
    ShippingScProductAdd,
    UpgradePlanModal,
    RequireUseScWarehouseModal,
    FixedHeader,
    UploadCsvModal,
    MaintenanceModal
  },
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      isMantenance: true,
      openShippingProductsAddConfirmModal: false,
      openAlertProductsAddedModal: false,
      openShippingProductAddModal: false,
      openAlertValidateFailsModal: false,
      isShowFixedHeader: false,
      shippingNo: null,
      shippingName: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      validateErrors: {
        shippingName: [],
        quantity: {},
        dueDateManagement: {}
      },
      selectedProducts: [],
      alertValidateFailsMessage: '入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。',
      shippingProductsAddConfirmMessage: '出荷情報を登録します。 よろしいですか？',
      stockInfo: [],
      isShowUpgradePlanModal: false,
      isShowRequireUseWarehouseModal: false,
      isShowUploadModal: false,
      settingProductIdOptions: [
        {
          value: 'ITEMID',
          text: '商品ID'
        },
        {
          value: 'FNSKU',
          text: '商品ラベル(FNSKU)'
        }
      ],
      totalUpload: 0,
      invalidUpload: [],
      duplicateUpload: [],
      openUploadedModal: false
    }
  },
  created () {
    if (this.$route.query.shippingNo && this.$route.query.shippingId) {
      this.getDetail(this.$route.query.shippingNo, this.$route.query.shippingId)
    } else {
      this.$router.push('/not-found')
    }
    this.isShowUpgradePlanModal = !this.isPremiumPlan
    this.isShowRequireUseWarehouseModal = this.isPremiumPlan && !this.isUseScWarehouse
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      iconUrls: 'getWareHouseIcons'
    }),
    alertProductsAddedMessage () {
      return `
        出荷情報を受付けました。 <br>
        出荷管理番号： ${this.shippingNo} <br> <br>
        <div>
          ACROSS倉庫からSTOCKCREW倉庫への出荷（納品）は自動的に行われますが<br>
          出荷プロセスにおいてエラーとなる可能性があります。<br> <br>
          詳しくは、別途ご送付するメールをご参照いただくか、 <br>
          または出荷状況照会画面よりご確認をお願いします。<br> <br>
          <span class="text-danger">※受取金額をご確認ください</span> <br>
          セルモンに出品している商品の場合、「商品管理 > 商品一覧」 画面にて <br>
          STOCKCREW倉庫商品の受取金額を確認・変更いただくことが可能です。
        </div>
      `
    },
    isPremiumPlan () {
      return this.$store.getters.getUser.memberPlan === '1'
    },
    isUseScWarehouse () {
      return this.$store.getters.getUser.scWarehouseUse === '1'
    },
    uploadCsvHeader () {
      return `<div class="flexbox">
        <img src="${this.$store.getters.getWareHouseIcons.salmonAcross}" class="w-20"> ACROSS倉庫 → <img src="${this.$store.getters.getWareHouseIcons.salmonSc}" class="w-20"> STOCKCREW倉庫へ納品する商品・数量をアップロードしてください
      </div>
      <span style="color: red; font-size: 14px;">「テンプレートをダウンロード」よりテンプレートをダウンロード・編集の上、ご登録ください。</span>
      `
    },
    uploadedMessage () {
      const successUpload = Math.max(0, this.totalUpload - this.invalidUpload.length - this.duplicateUpload.length)
      let html = `<p><b>${successUpload}件/${this.totalUpload}件 商品の追加が成功しました</b></p>`

      if (this.invalidUpload.length > 0) {
        html += `<div class="text-danger"><b>エラー${this.invalidUpload.length}件 商品が存在しません</b></div>`
        this.invalidUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      if (this.duplicateUpload.length > 0) {
        html += '<br>'
        html += `<div class="text-danger"><b>エラー${this.duplicateUpload.length}件 商品が重複しています</b></div>`
        this.duplicateUpload.forEach(asin => {
          html += `<span class="text-danger">${asin}</span> <br />`
        })
      }

      return html
    }
  },
  methods: {
    bypassMaintenance () {
      $('#maintenance-modal').modal('hide')
      this.isMantenance = false
    },
    closeMaintenanceModal () {
      $('#maintenance-modal').modal('hide')
      this.$router.push('/warehouse-across/shipping/shipping-status-inquiry')
    },
    closeRequireUseWarehouseModal () {
      this.isShowRequireUseWarehouseModal = false
      $('#require-use-warehouse-modal').modal('hide')
    },
    closeModalProductAdd () {
      $('#shipping-product-add-modal').modal('hide')
      this.openShippingProductAddModal = false
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    openModalConfirmShippingProductsAdd () {
      if (this.isValidateFails) return
      this.openShippingProductsAddConfirmModal = true
    },
    closeModalConfirmShippingProductsAdd () {
      $('#confirm-alert').modal('hide')
      this.openShippingProductsAddConfirmModal = false
    },
    openModalAlertProductsAdded () {
      this.openAlertProductsAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAlertProductsAddedModal = false
      this.shippingName = null
      this.shippingNo = null
      this.$router.push({
        name: 'Warehouse across',
        params: {
          tab: 'shipping',
          subTab: 'shipping-status-inquiry'
        }
      })
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    deleteSelectedProduct (product) {
      this.selectedProducts = this.selectedProducts.filter(item => item.itemId !== product.itemId)
    },
    handleSelectedProduct (product) {
      this.selectedProducts.push(product)
    },
    handleSelectedProducts (products) {
      this.selectedProducts = [...this.selectedProducts, ...products]
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    formatNumber (number) {
      if (number === null) {
        return '-'
      }
      return Util.formatMoney(number)
    },
    openModalDeliveryProductAdd () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.sc_shipping.click_select_product_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.openShippingProductAddModal = true
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
    },
    async submitValidate () {
      this.loader = this.$loading.show()
      let params = {
        shippingGoods: this.selectedProducts
      }
      await WarehouseAcrossService.getShippingStockInfo(params)
        .then((response) => {
          this.selectedProducts = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })

      await this.validateInput()

      this.loader && this.loader.hide()
    },
    validateInput () {
      let required = '※必ず入力してください'
      let validateMin = '※1以上の数値を入力してください'
      let validateMax = '※ACROSS在庫数以内で入力してください'
      let expDate = '※有効期限毎の在庫数内で入力してください'
      this.isValidateFails = false
      if (!this.shippingName || !this.shippingName.trim()) {
        this.validateErrors.shippingName.push(required)
        this.isValidateFails = true
      } else {
        this.validateErrors.shippingName = []
      }
      this.selectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let itemId = product.itemId
        this.validateErrors.quantity[itemId] = []
        if (isNaN(quantity)) {
          this.validateErrors.quantity[itemId][0] = required
          this.isValidateFails = true
        } else if (quantity === 0) {
          this.validateErrors.quantity[itemId][0] = validateMin
          this.isValidateFails = true
        } else if (!product.dueDateManageFlg && quantity > product.acrossQuantity) {
          this.validateErrors.quantity[itemId][0] = validateMax
          this.isValidateFails = true
        } else if (product.dueDateManageFlg) {
          let mapQuantity = product.stockInfo.map((value) => value['quantity'])
          let maxInStock = Math.max(...mapQuantity)
          if (quantity > maxInStock) {
            this.validateErrors.quantity[itemId][0] = expDate
            this.isValidateFails = true
          }
        } else {
          delete this.validateErrors.quantity[itemId]
        }
      })

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmShippingProductsAdd()
      }
    },
    updateShippingSc () {
      if (this.isValidateFails) return

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.sc_shipping.click_request_shipping_btn,
        properties: {
          shippingNo: this.shippingNo,
          shippingId: this.shippingId
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      let params = {
        shippingNo: this.shippingNo,
        shippingId: this.shippingId,
        shippingGoods: this.selectedProducts,
        shippingName: this.shippingName
      }
      WarehouseAcrossService.updateShippingSc(params)
        .then((response) => {
          this.closeModalConfirmShippingProductsAdd()
          this.shippingNo = response.data.shippingNo
          this.openModalAlertProductsAdded()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    getStockByExpDate (event, product) {
      if (!product.dueDateManageFlg) {
        return false
      }

      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.sc_shipping.click_display_by_exp_date_link,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      let params = {
        itemId: product.itemId
      }
      WarehouseAcrossService.getStockByExpDate(params)
        .then((response) => {
          this.stockInfo = response.data
          $(event.target).siblings('.bubble').show()
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    closeBubble (event) {
      $(event.target).siblings('.bubble').hide()
    },
    async getDetail (shippingNo, shippingId) {
      this.loader = this.$loading.show()
      let params = {
        shippingNo: shippingNo,
        shippingId: shippingId
      }
      await WarehouseAcrossService.getShippingSc(params)
        .then((response) => {
          this.shippingNo = response.data.shippingNo
          this.shippingId = response.data.shippingId
          this.shippingName = response.data.shippingName
          this.selectedProducts = response.data.shippingGoods
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleScroll () {
      const fixedHeader = document.getElementById('product-input')
      const initialOffset = fixedHeader.getBoundingClientRect().top + window.scrollY
      this.isShowFixedHeader = window.scrollY >= initialOffset
    },
    handleInputQuantity (value) {
      return value.replace(/[^0-9]/g, '').replace(/^0+/, '')
    },
    openModalUpload () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.sc_shipping.click_upload_by_csv,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.isShowUploadModal = true
    },
    closeUploadModal () {
      this.isShowUploadModal = false
      $('#upload-csv-modal').modal('hide')
    },
    closeUploadedModal () {
      this.openUploadedModal = false
      $('#myModal').modal('hide')
    },
    handleDownloadTemplate () {
      let logParams = {
        name: eventCode.warehouse_across.shipping_tab.sc_shipping.click_download_template,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      WarehouseAcrossService.downloadProductsCsvTemplate({}, '出荷テンプレート.csv')
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    },
    handleUploadSuccess (response) {
      const data = response.records.data
      this.totalUpload = data.total
      this.invalidUpload = data.invalid
      this.duplicateUpload = data.duplicate
      this.selectedProducts = []
      this.handleSelectedProducts(data.products)
      this.closeUploadModal()
      this.openUploadedModal = true
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmouted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped>
.step-rectangle {
  border: 2px solid #008cc6;
  border-radius: 8px;
  padding: 5px;
  width: 350px;
  height: 70px;
}
.text-primary {
  color: #008cc6;
}
.table-selected-products {
  margin-top: 10px;
  /* overflow: auto; */
  padding: 0
}
.table-selected-products table {
  border: 1px solid #ccc
}
.table-selected-products th, .table-selected-products td{
  padding: 5px 10px;
  min-width: 120px;
  height: auto;
  border-bottom: 1px solid #ccc;
}
.table-selected-products th {
  color: #595959;
  background-color: #deebf7;
}
.td-vertical-top {
  vertical-align: top;
}
#shipping-sc {
  overflow: auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.bubble {
  position: absolute;
  top: 35px;
  width: 200px;
  background: #f2f7fc;
  margin: 0 auto;
  border: 2px solid #008cc6;
  padding: 5px 10px;
}
.bubble:before {
    border-width: 0 20px 12px 20px;
    top: -12px;
    left: 50%;
}
.bubble:after {
    border-width: 0 20px 12px 20px;
    top: -10px;
    left: 50%;
}
.product-bubble::before {
  border-color: #008cc6 transparent;
}
.text-warning {
  background-color: #fff2cc;
}
.bg-warning {
  color: #843c0b;
}
.custom-btn {
  font-size: 20px;
  padding: 10px 50px;
  border-radius: 8px;
  background-color: #0070c0;
}
</style>
<style>
#shipping-sc .bg-no-input {
  background-color: #fdefef !important;
}
#shipping-sc .row {
  margin-left: -15px;
  margin-right: -15px;
}
#shipping-sc .mx-datepicker {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/EditScShipping.vue